
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.344 4.75c.164 0 .328.082.465.191.109.137.191.301.191.465a.66.66 0 01-.191.465L13.75 10.93v7.164a.65.65 0 01-.355.601c-.247.11-.465.11-.684-.054l-2.188-1.532a.638.638 0 01-.273-.547V10.93L5.191 5.87C5.055 5.761 5 5.598 5 5.406a.64.64 0 01.191-.465.66.66 0 01.465-.191h12.688z","fill":"#24242E"}})])
          )
        }
      }
    